import React, { useState, useEffect } from 'react';
import { Col, Row, Badge, Spinner } from 'reactstrap';
import { Link } from 'react-router-dom';
import { getRecentValuations } from '../../services/ValitanApiService';


const LatestValuations = () => {
    const [valuations, setValuations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchRecentValuations = async () => {
            try {
                setLoading(true);
                const response = await getRecentValuations();
                setValuations(response.data.data || []);
            } catch (err) {
                console.error('Failed to load recent valuations:', err);
                setError('Failed to load recent valuations');
            } finally {
                setLoading(false);
            }
        };

        fetchRecentValuations();
    }, []);

    // Status badge color mapping (Tanzanian enterprise style)
    const getStatusBadge = (status) => {
        switch (status?.toUpperCase()) {
            case 'DRAFT':
                return <Badge color="warning" pill>Draft</Badge>;
            case 'SUBMITTED':
                return <Badge color="info" pill>Submitted</Badge>;
            case 'APPROVED':
                return <Badge color="success" pill>Approved</Badge>;
            case 'REJECTED':
                return <Badge color="danger" pill>Rejected</Badge>;
            default:
                return <Badge color="secondary" pill>{status}</Badge>;
        }
    };

    if (loading) {
        return (
            <Row>
                <Col lg={12}>
                    <div className="card dashboard-widget">
                        <div className="card-body text-center py-5">
                            <Spinner color="primary" /> Loading latest valuations...
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }

    if (error) {
        return (
            <Row>
                <Col lg={12}>
                    <div className="card dashboard-widget">
                        <div className="card-body text-center text-danger">
                            {error}
                        </div>
                    </div>
                </Col>
            </Row>
        );
    }

    return (
        <React.Fragment>
            <Row>
                <Col lg={12}>
                    <div className="card dashboard-widget">
                        <div className="card-body">
                            <div className="widget-header">
                                <div>
                                    <h4 className="widget-title">Latest Valuations</h4>
                                    <p className="widget-copy">Recently created or updated valuation records requiring visibility.</p>
                                </div>
                                <Link to="/valuations" className="btn btn-sm btn-outline-primary rounded-pill px-3">
                                    View All
                                </Link>
                            </div>

                            <div className="table-responsive dashboard-table">
                                <table className="table table-centered table-nowrap mb-0 align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Reference & Project</th>
                                            <th>Type</th>
                                            <th>Valuer</th>
                                            <th>Client</th>
                                            <th>Date</th>
                                            <th>Status</th>
                                            {/* <th>Action</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {valuations.length === 0 ? (
                                            <tr>
                                                <td colSpan="7" className="text-center text-muted py-4">
                                                    No recent valuations found
                                                </td>
                                            </tr>
                                        ) : (
                                            valuations.map((item, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <div>
                                                            <p className="mb-1 font-size-13 text-primary fw-medium">
                                                                {item.reference}
                                                            </p>
                                                            <h6 className="mb-0 font-size-14">{item.project_name}</h6>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span className="badge badge-soft-info font-size-12">
                                                            {item.valuation_type}
                                                        </span>
                                                    </td>
                                                    <td className="text-muted font-size-13">
                                                        {item.valuer_name}
                                                    </td>
                                                    <td className="text-muted font-size-13">
                                                        {item.client_name}
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <div className="font-size-13">{item.valuation_date}</div>
                                                            <small className="text-muted">{item.created_at}</small>
                                                        </div>
                                                    </td>
                                                    <td>{getStatusBadge(item.status)}</td>
                                                    {/* <td>
                                                        <Link
                                                            to={`/valuations/${item.reference}`}
                                                            className="btn btn-sm btn-outline-success"
                                                        >
                                                            View
                                                        </Link>
                                                    </td> */}
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default LatestValuations;
